/** Shared mobile production UI — matches DriverHandoff.jsx */
export const PINK = "#EE2677";
export const HELP_RED = "#DC2626";
export const TABLETOP_LOGO_SRC = `${process.env.PUBLIC_URL || ""}/tabletop-logo.png`;

/** Compact sticky header for driver / production mobile pages */
export const MOBILE_TASK_HEADER_CSS = `
  .driver-top {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    margin-bottom: 10px;
    position: sticky;
    top: 0;
    z-index: 20;
    background: #F5F2EA;
    padding: 2px 0 6px;
  }
  .driver-brand { display: flex; align-items: center; gap: 8px; min-width: 0; }
  .driver-logo {
    width: 32px; height: 32px; border-radius: 50%;
    background: ${PINK}; color: white;
    display: flex; align-items: center; justify-content: center; flex-shrink: 0;
  }
  .driver-logo--brand {
    background: white;
    border: 1.5px solid #EBB3A9;
    overflow: hidden;
    padding: 0;
  }
  .driver-logo--brand img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
  }
  .driver-title { font-size: 15px; font-weight: 800; line-height: 1.15; }
  .driver-subtitle { font-size: 11px; color: rgba(45,45,45,0.5); }
  .driver-help-btn {
    display: inline-flex; align-items: center; gap: 4px;
    background: ${HELP_RED}; color: white;
    border: none; border-radius: 999px;
    padding: 7px 10px; font-size: 11px; font-weight: 800;
    text-decoration: none; flex-shrink: 0;
    box-shadow: 0 2px 6px rgba(220,38,38,0.28);
  }
  .driver-top--compact .driver-logo { width: 26px; height: 26px; }
  .driver-top--compact .driver-title { font-size: 14px; }
  .driver-top--compact .driver-subtitle { display: none; }
  .driver-top--compact .driver-help-btn { padding: 6px 9px; font-size: 10px; }
  .driver-top-actions {
    display: inline-flex; align-items: center; gap: 6px; flex-shrink: 0;
  }
  .driver-lang-btn {
    display: inline-flex; align-items: center; justify-content: center;
    background: white; color: #2D2D2D;
    border: 1.5px solid #EBB3A9; border-radius: 999px;
    padding: 7px 10px; font-size: 11px; font-weight: 800;
    cursor: pointer; flex-shrink: 0;
    box-shadow: 0 2px 6px rgba(0,0,0,0.06);
    min-width: 44px;
  }
  .driver-top--compact .driver-lang-btn { padding: 6px 9px; font-size: 10px; min-width: 40px; }
`;

export const MOBILE_CAKE_PROOF_CSS = `
  .driver-cake-proof-card { margin-top: 0; }
  .driver-cake-proof-title { font-size: 14px; font-weight: 900; color: #0F766E; margin-bottom: 4px; }
  .driver-cake-proof-hint { font-size: 12px; color: #555; line-height: 1.35; margin-bottom: 10px; }
  .driver-cake-proof-weight {
    display: inline-flex; align-items: center; gap: 6px;
    margin-bottom: 10px; padding: 6px 10px; border-radius: 999px;
    background: #FFEAF2; color: #C2185B; font-size: 13px; font-weight: 800;
  }
  .driver-cake-proof-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 8px; }
  .driver-cake-proof-shot {
    overflow: hidden; border-radius: 12px; border: 1px solid rgba(15,118,110,0.2); background: #fff;
  }
  .driver-cake-proof-shot img { width: 100%; aspect-ratio: 1; object-fit: cover; display: block; }
  .driver-cake-proof-shot-label {
    padding: 6px 8px; font-size: 11px; font-weight: 800; color: #0F766E; text-align: center;
    border-top: 1px solid rgba(15,118,110,0.15);
  }
  .driver-cake-proof-link {
    display: block; margin-top: 10px; text-align: center;
    font-size: 13px; font-weight: 800; color: ${PINK}; text-decoration: underline;
  }
  .driver-photo-slot { margin-top: 14px; padding-top: 14px; border-top: 1px solid rgba(15,118,110,0.2); }
  .driver-photo-slot:first-child { margin-top: 0; padding-top: 0; border-top: none; }
  .driver-photo-slot-title { font-size: 13px; font-weight: 800; color: #0F766E; margin-bottom: 6px; }
  .driver-photo-slot-hint { font-size: 11px; color: #666; line-height: 1.35; margin-bottom: 8px; }
  .driver-photo-preview {
    width: 100%; border-radius: 14px; object-fit: cover; max-height: 220px;
    border: 1px solid #F2D4CE; margin-bottom: 10px; display: block;
  }
  .driver-check-grid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 8px; margin-top: 8px; }
  .driver-check-pill {
    display: flex; align-items: center; justify-content: center; gap: 4px;
    border-radius: 12px; padding: 10px 6px; font-size: 11px; font-weight: 700;
    cursor: pointer; border: 1px solid #D9D9D9; background: white; color: #555;
  }
  .driver-check-pill--on {
    border-color: ${PINK}; background: #FFEAF2; color: #C2185B;
  }
  .driver-ref-img {
    width: 100%; border-radius: 14px; object-fit: cover; max-height: 180px;
    border: 1px dashed #EBB3A9; margin-top: 8px;
  }
  .driver-ref-note { font-size: 11px; color: #888; margin-top: 6px; line-height: 1.35; }
  .driver-cake-proof-stack { display: flex; flex-direction: column; gap: 12px; }
  .driver-call-card {
    border-radius: 16px; padding: 14px; margin-bottom: 12px;
    border: 1px solid #F9A8D4; background: #FDF2F8;
  }
  .driver-call-card--compact {
    display: flex; flex-direction: column; align-items: center; gap: 10px; padding: 12px 14px;
  }
  .driver-call-card--compact.driver-call-card--done {
    flex-direction: row; justify-content: center; gap: 8px;
    font-size: 14px; font-weight: 800; color: #166534;
  }
  .driver-call-actions { display: flex; justify-content: center; align-items: center; gap: 10px; width: 100%; }
  .driver-call-missing { font-size: 12px; font-weight: 700; color: #9D174D; }
  .driver-call-card--done { border-color: #BBF7D0; background: #F0FDF4; }
  .driver-call-label { font-size: 12px; font-weight: 900; color: #BE185D; text-transform: uppercase; letter-spacing: 0.04em; margin-bottom: 6px; }
  .driver-call-hint { font-size: 13px; line-height: 1.4; color: #831843; margin: 0; flex: 1; }
  .driver-call-row { display: flex; align-items: flex-start; gap: 10px; }
  .driver-call-round-btn {
    width: 48px; height: 48px; min-width: 48px; border-radius: 999px; border: none;
    background: #EC4899; color: white; display: flex; align-items: center; justify-content: center;
    cursor: pointer; box-shadow: 0 2px 8px rgba(236,72,153,0.35);
  }
  .driver-call-round-btn:disabled { opacity: 0.45; cursor: not-allowed; }
  .driver-call-wa-round-btn {
    width: 48px; height: 48px; min-width: 48px; border-radius: 999px; border: none;
    background: #25D366; color: white; display: flex; align-items: center; justify-content: center;
    cursor: pointer; box-shadow: 0 2px 8px rgba(37, 211, 102, 0.35);
  }
  .driver-call-wa-round-btn:disabled { opacity: 0.45; cursor: not-allowed; }
  .driver-call-timer {
    width: 100%; display: flex; align-items: center; justify-content: center; gap: 6px;
    font-size: 13px; font-weight: 800; color: #9D174D; padding: 8px; border-radius: 10px; background: rgba(255,255,255,0.75);
  }
  .driver-call-done-round {
    width: 100%; padding: 12px; border-radius: 999px; border: none;
    background: #DB2777; color: white; font-size: 14px; font-weight: 800; cursor: pointer;
  }
  .driver-call-done-round:disabled { opacity: 0.45; cursor: not-allowed; }
  .driver-error {
    margin: 0 14px 12px; padding: 12px 14px; border-radius: 12px;
    background: #FEF2F2; border: 1px solid #FECACA; color: #B91C1C; font-size: 13px; font-weight: 600;
  }
  .driver-cake-proof-hero {
    overflow: hidden; border-radius: 16px; border: 1px solid rgba(15,118,110,0.25);
    background: #fff; cursor: pointer; text-align: left; padding: 0; width: 100%;
  }
  .driver-cake-proof-hero img {
    width: 100%; max-height: 420px; object-fit: cover; display: block;
  }
  .driver-cake-proof-hero-label {
    padding: 10px 12px; font-size: 12px; font-weight: 800; color: #0F766E;
    border-top: 1px solid rgba(15,118,110,0.15); background: #FAFAFA;
  }
  .driver-cake-proof-tap { font-size: 11px; color: #888; font-weight: 600; margin-left: 6px; }
  .driver-lightbox {
    position: fixed; inset: 0; z-index: 100; background: rgba(0,0,0,0.92);
    display: flex; align-items: center; justify-content: center; padding: 12px;
  }
  .driver-lightbox-inner {
    width: 100%; max-width: 480px; max-height: 100dvh; display: flex;
    flex-direction: column; align-items: stretch;
  }
  .driver-lightbox-close {
    align-self: flex-end; margin-bottom: 8px; border: none; border-radius: 999px;
    background: rgba(255,255,255,0.15); color: white; font-size: 14px; font-weight: 800;
    padding: 8px 14px; cursor: pointer;
  }
  .driver-lightbox-label {
    color: white; font-size: 13px; font-weight: 700; margin: 0 0 8px; text-align: center;
  }
  .driver-lightbox-img {
    width: 100%; max-height: calc(100dvh - 80px); object-fit: contain;
    border-radius: 12px; background: #111;
  }
  .driver-photo-slot--compact .driver-photo-slot-hint { display: none; }
`;

export const PRODUCTION_DRIVER_PAGE_CSS = `
  .driver-page {
    min-height: 100dvh;
    background: #F5F2EA;
    color: #2D2D2D;
    padding: 12px 14px 168px;
    max-width: 480px;
    margin: 0 auto;
    overflow-x: hidden;
    box-sizing: border-box;
    font-family: system-ui, -apple-system, "Segoe UI", Roboto, sans-serif;
  }
  .driver-page * { box-sizing: border-box; }
  .driver-top {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 10px;
    margin-bottom: 14px;
    position: sticky;
    top: 0;
    z-index: 20;
    background: #F5F2EA;
    padding: 4px 0 10px;
  }
  .driver-brand { display: flex; align-items: center; gap: 10px; min-width: 0; }
  .driver-logo {
    width: 44px; height: 44px; border-radius: 50%;
    background: ${PINK}; color: white;
    display: flex; align-items: center; justify-content: center; flex-shrink: 0;
  }
  .driver-logo--brand {
    background: white;
    border: 2px solid #EBB3A9;
    overflow: hidden;
    padding: 0;
  }
  .driver-logo--brand img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
  }
  .driver-title { font-size: 18px; font-weight: 800; line-height: 1.15; }
  .driver-subtitle { font-size: 12px; color: rgba(45,45,45,0.55); }
  .driver-help-btn {
    display: inline-flex; align-items: center; gap: 6px;
    background: ${HELP_RED}; color: white;
    border: none; border-radius: 999px;
    padding: 10px 14px; font-size: 13px; font-weight: 800;
    text-decoration: none; flex-shrink: 0;
    box-shadow: 0 2px 8px rgba(220,38,38,0.35);
  }
  .driver-card {
    background: white;
    border: 1px solid #EBB3A9;
    border-radius: 18px;
    padding: 16px;
    margin-bottom: 12px;
    box-shadow: 0 2px 8px rgba(0,0,0,0.06);
  }
  .driver-label {
    font-size: 10px; text-transform: uppercase; letter-spacing: 0.6px;
    color: rgba(45,45,45,0.45); margin-bottom: 4px; font-weight: 700;
  }
  .driver-order-num { font-size: 14px; font-weight: 700; color: #2D2D2D; line-height: 1.2; }
  .driver-customer-name { font-size: 26px; font-weight: 900; color: ${PINK}; line-height: 1.15; margin-top: 4px; text-transform: uppercase; }
  .driver-slot { font-size: 13px; color: rgba(45,45,45,0.55); margin-top: 6px; }
  .driver-notes-card {
    background: #FFFBEB; border: 1px solid #FCD34D;
    border-radius: 14px; padding: 12px 14px; margin-bottom: 12px;
    font-size: 14px; line-height: 1.45; color: #78350F;
  }
  .driver-item-pill {
    display: inline-flex; align-items: center; gap: 4px; margin-top: 8px; padding: 6px 12px;
    background: #FCE7F3; color: ${PINK}; border-radius: 999px;
    font-size: 13px; font-weight: 700;
  }
  .driver-frost-line {
    display: flex; flex-wrap: nowrap; align-items: center; gap: 8px;
    margin-top: 10px; overflow-x: auto; -webkit-overflow-scrolling: touch;
  }
  .driver-frost-chip {
    display: inline-flex; align-items: center; justify-content: center;
    flex-shrink: 0; height: 32px; padding: 0 12px; border-radius: 999px;
    font-size: 13px; font-weight: 700; white-space: nowrap;
  }
  .driver-frost-chip--flavor,
  .driver-frost-chip--weight {
    background: #FCE7F3; color: ${PINK};
  }
  .driver-frost-tag {
    display: inline-flex; align-items: center; justify-content: center;
    flex-shrink: 0; height: 32px; padding: 0 12px; border-radius: 999px;
    font-size: 12px; font-weight: 800; letter-spacing: 0.02em;
    white-space: nowrap;
  }
  .driver-frost-tag--custom {
    background: ${PINK}; color: white;
    box-shadow: 0 2px 8px rgba(238, 38, 119, 0.28);
  }
  .driver-frost-tag--rtg {
    background: #2D2D2D; color: white;
    box-shadow: 0 2px 8px rgba(45, 45, 45, 0.2);
  }
  .driver-frost-tag--tier {
    background: white; color: ${PINK};
    border: 2px solid ${PINK};
  }
  .driver-error {
    background: #FEF2F2; border: 1px solid #FECACA;
    border-radius: 12px; padding: 12px; font-size: 14px;
    color: #B91C1C; margin-bottom: 12px;
  }
  .driver-success {
    background: #F0FDF4; border: 1px solid #BBF7D0;
    border-radius: 12px; padding: 12px; font-size: 14px;
    color: #166534; margin-bottom: 12px;
    display: flex; align-items: center; gap: 8px; font-weight: 600;
  }
  .driver-detail-line { font-size: 15px; line-height: 1.4; margin-top: 6px; }
  .driver-detail-line strong { font-weight: 800; }
  .driver-cake-img {
    width: 100%; border-radius: 14px; object-fit: cover;
    max-height: 220px; border: 1px solid #F2D4CE;
  }
  .driver-footer {
    position: fixed; left: 0; right: 0; bottom: 0;
    z-index: 40;
    padding: 12px 14px calc(12px + env(safe-area-inset-bottom));
    background: linear-gradient(180deg, rgba(245,242,234,0) 0%, #F5F2EA 28%, #F5F2EA 100%);
    max-width: 480px; margin: 0 auto;
  }
  .driver-frost-card {
    margin-bottom: 8px;
    overflow: hidden;
    max-width: 100%;
    min-width: 0;
  }
  .driver-frost-card > div {
    max-width: 100%;
    min-width: 0;
  }
  .driver-btn-done {
    width: 100%; padding: 16px; border-radius: 999px;
    font-size: 16px; font-weight: 800; border: none; cursor: pointer;
    background: ${PINK}; color: white;
    box-shadow: 0 4px 14px rgba(238,38,119,0.4);
  }
  .driver-btn-done:disabled { opacity: 0.5; cursor: not-allowed; }
  .driver-btn-done--complete { background: #15803D; box-shadow: 0 4px 14px rgba(21,128,61,0.35); }
  .driver-frost-intro {
    font-size: 12px; line-height: 1.45; color: rgba(45,45,45,0.65);
    margin-top: 4px;
  }
  .driver-frost-block { margin-bottom: 12px; }
  .driver-frost-block-title { font-size: 15px; font-weight: 800; color: #2D2D2D; }
  .driver-frost-tier-note {
    background: #F5F3FF; border: 1px solid #DDD6FE;
    border-radius: 12px; padding: 10px 12px; margin: 10px 0;
    font-size: 12px; line-height: 1.4; color: #5B21B6;
  }
  .driver-frost-tier-base {
    border: 1px solid #EBB3A9; border-radius: 14px;
    background: #FAFAFA; margin-top: 10px; overflow: hidden;
  }
  .driver-frost-tier-head {
    padding: 10px 12px; font-size: 13px; font-weight: 800;
    background: white; border-bottom: 1px solid #F2D4CE;
  }
  .driver-grid-2 { display: grid; grid-template-columns: 1fr 1fr; gap: 10px; }
  .driver-input {
    width: 100%; padding: 12px; border: 1px solid #E5E7EB;
    border-radius: 10px; font-size: 16px; font-weight: 700; outline: none;
  }
  .driver-input:focus {
    border-color: ${PINK}; box-shadow: 0 0 0 2px rgba(238,38,119,0.12);
  }
  .driver-input-label {
    font-size: 10px; text-transform: uppercase; letter-spacing: 0.5px;
    font-weight: 700; color: rgba(45,45,45,0.5); margin-bottom: 4px;
  }
  .driver-frost-table { width: 100%; font-size: 12px; border-collapse: collapse; }
  .driver-frost-table th {
    text-align: left; padding: 8px 6px; font-weight: 700;
    color: rgba(45,45,45,0.55); border-bottom: 1px solid #F2D4CE;
    font-size: 10px; text-transform: uppercase;
  }
  .driver-frost-table th.num { text-align: right; }
  .driver-frost-table td {
    padding: 8px 6px; border-bottom: 1px solid #F5F5F5;
    font-variant-numeric: tabular-nums;
  }
  .driver-frost-table td.num { text-align: right; }
  .driver-frost-table td.code { font-weight: 800; }
  .driver-frost-table td.layer { font-weight: 800; color: ${PINK}; text-align: right; }
  .driver-frost-table tr.total td { font-weight: 800; border-top: 2px solid #EBB3A9; background: #FFF7FA; }
  .driver-frost-formula {
    padding: 8px 12px 10px; font-size: 11px; line-height: 1.4;
    color: rgba(45,45,45,0.65); border-top: 1px solid #F2D4CE;
  }
  .driver-frost-formula strong { color: ${PINK}; }
  .driver-frost-tier-stack {
    display: flex;
    flex-direction: column;
    gap: 14px;
    margin-top: 12px;
    max-width: 100%;
    min-width: 0;
  }
  .driver-frost-base-panel {
    border: 2px solid #EBB3A9;
    border-radius: 16px;
    background: white;
    overflow: hidden;
    width: 100%;
    max-width: 100%;
    min-width: 0;
  }
  .driver-frost-base-head {
    padding: 5px 8px;
    font-size: 9px;
    font-weight: 800;
    color: ${PINK};
    text-align: center;
    letter-spacing: 0.06em;
    background: #FFF7FA;
    border-bottom: 1px solid #F2D4CE;
  }
  .driver-frost-base-head--toolbar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    text-align: left;
    padding: 8px 10px;
    font-size: 11px;
  }
  .driver-calc-add-base {
    width: 100%;
    margin-top: 12px;
    padding: 12px 14px;
    border: 2px dashed #EBB3A9;
    border-radius: 14px;
    background: #FFF7FA;
    color: ${PINK};
    font-size: 14px;
    font-weight: 800;
    cursor: pointer;
  }
  .driver-calc-add-base:active {
    transform: scale(0.99);
    background: #FCE7F3;
  }
  .driver-calc-remove-base {
    border: none;
    background: transparent;
    color: rgba(45,45,45,0.45);
    font-size: 11px;
    font-weight: 700;
    padding: 4px 6px;
    cursor: pointer;
    flex-shrink: 0;
  }
  .driver-calc-remove-base:active {
    color: #DC2626;
  }
  .driver-frost-base-inputs {
    display: grid;
    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
    gap: 8px;
    padding: 10px;
    background: #FAFAFA;
    border-bottom: 1px solid #F2D4CE;
    width: 100%;
    max-width: 100%;
    min-width: 0;
    box-sizing: border-box;
  }
  .driver-frost-base-inputs > * {
    min-width: 0;
    max-width: 100%;
  }
  .driver-frost-stepper {
    display: flex;
    align-items: stretch;
    width: 100%;
    max-width: 100%;
    min-width: 0;
    border: 2px solid #EBB3A9;
    border-radius: 12px;
    overflow: hidden;
    background: white;
  }
  .driver-frost-stepper-btn {
    flex: 0 0 40px;
    border: none;
    background: #FFF7FA;
    color: ${PINK};
    font-size: 26px;
    font-weight: 800;
    line-height: 1;
    cursor: pointer;
    border-right: 1px solid #F2D4CE;
  }
  .driver-frost-stepper-btn--plus {
    border-right: none;
    border-left: 1px solid #F2D4CE;
  }
  .driver-frost-stepper-btn:active {
    background: #FCE7F3;
  }
  .driver-frost-base-table-wrap {
    padding: 8px 6px 10px;
    width: 100%;
    max-width: 100%;
    min-width: 0;
    overflow: hidden;
  }
  .driver-frost-stepper-value {
    flex: 1;
    min-width: 0;
    border: none;
    background: white;
    text-align: center;
    font-size: 20px;
    font-weight: 800;
    color: #2D2D2D;
    padding: 12px 4px;
    outline: none;
  }
  .driver-frost-table--work {
    width: 100%;
    font-size: 15px;
    border-collapse: collapse;
  }
  .driver-frost-table--work th {
    text-align: left;
    padding: 10px 8px;
    font-weight: 800;
    font-size: 11px;
    text-transform: uppercase;
    letter-spacing: 0.04em;
    color: rgba(45, 45, 45, 0.55);
    border-bottom: 2px solid #F2D4CE;
  }
  .driver-frost-table--work th.num { text-align: right; }
  .driver-frost-table--work td {
    padding: 12px 8px;
    border-bottom: 1px solid #F5F5F5;
    font-variant-numeric: tabular-nums;
    font-size: 15px;
  }
  .driver-frost-table--work td.code {
    font-weight: 900;
    font-size: 17px;
    color: #2D2D2D;
  }
  .driver-frost-table--work td.num { text-align: right; font-weight: 700; }
  .driver-frost-table--work td.layer {
    text-align: right;
    font-weight: 900;
    font-size: 16px;
    color: ${PINK};
  }
  .driver-frost-table--work tr.total td {
    font-weight: 900;
    font-size: 14px;
    border-top: 2px solid #EBB3A9;
    background: #FFF7FA;
  }
  .driver-frost-table-h-scroll {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    width: 100%;
    max-width: 100%;
    min-width: 0;
    padding-bottom: 4px;
  }
  .driver-frost-table--horizontal {
    table-layout: auto;
    width: max-content;
    min-width: 100%;
  }
  .driver-frost-table--horizontal th.row-label,
  .driver-frost-table--horizontal td.row-label {
    text-align: left;
    font-weight: 800;
    font-size: 9px;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    color: rgba(45, 45, 45, 0.55);
    padding: 8px 6px;
    white-space: nowrap;
    position: sticky;
    left: 0;
    z-index: 2;
    background: white;
    border-right: 2px solid #EBB3A9;
  }
  .driver-frost-table--horizontal th.row-label.row-label--sm {
    font-size: 8px;
    padding: 7px 5px;
  }
  .driver-frost-table--horizontal {
    border-collapse: separate;
    border-spacing: 0;
    border: 2px solid #EBB3A9;
    border-radius: 10px;
    overflow: hidden;
  }
  .driver-frost-table--horizontal th,
  .driver-frost-table--horizontal td {
    border: 1px solid #EBB3A9;
  }
  .driver-frost-table--horizontal th.code-col,
  .driver-frost-table--horizontal td.num,
  .driver-frost-table--horizontal td.layer {
    text-align: center;
    padding: 9px 6px;
    min-width: 2.6rem;
    font-size: 14px;
    font-weight: 700;
    font-variant-numeric: tabular-nums;
  }
  .driver-frost-table--horizontal th.code-col {
    font-size: 15px;
    font-weight: 900;
    color: #2D2D2D;
    background: #FAFAFA;
    border-bottom: 2px solid #EBB3A9;
  }
  .driver-frost-table--horizontal th.code-col.total-col,
  .driver-frost-table--horizontal td.total-col {
    font-weight: 900;
    background: #FFF7FA;
    border-left: 2px solid #EBB3A9;
  }
  .driver-frost-table--horizontal tr.total-data-row th,
  .driver-frost-table--horizontal tr.total-data-row td {
    border-bottom: 2px solid #EBB3A9;
    background: #FFFCFD;
  }
  .driver-frost-table--horizontal tr.layer-row td.layer,
  .driver-frost-table--horizontal tr.layer-row th.row-label {
    color: ${PINK};
  }
  .driver-frost-table--horizontal tr.layer-row th.row-label {
    background: #FFF7FA;
  }
  .driver-frost-table--horizontal tr.layer-row td,
  .driver-frost-table--horizontal tr.layer-row th {
    border-top: 2px solid #EBB3A9;
  }
  .driver-frost-table--basic.driver-frost-table--horizontal {
    width: 100%;
    font-size: 14px;
    border-collapse: separate;
    border-spacing: 0;
    border: 2px solid #EBB3A9;
    border-radius: 10px;
    overflow: hidden;
  }
  .driver-frost-table--basic.driver-frost-table--horizontal th,
  .driver-frost-table--basic.driver-frost-table--horizontal td {
    border: 1px solid #EBB3A9 !important;
  }
  .driver-frost-table--basic.driver-frost-table--horizontal thead th {
    border-bottom: 2px solid #EBB3A9 !important;
    color: rgba(45, 45, 45, 0.65);
  }
  .driver-frost-table--basic.driver-frost-table--horizontal tbody tr.basic-data-row th,
  .driver-frost-table--basic.driver-frost-table--horizontal tbody tr.basic-data-row td {
    border-top: 2px solid #EBB3A9 !important;
  }
  .driver-frost-table--basic.driver-frost-table--horizontal tbody tr:last-child th,
  .driver-frost-table--basic.driver-frost-table--horizontal tbody tr:last-child td {
    border-bottom: 1px solid #EBB3A9 !important;
  }
  .driver-frost-table--basic.driver-frost-table--horizontal tbody tr th.row-label {
    font-size: 8px;
    background: #FFFCFD;
  }
  .driver-frost-ingredients-bar {
    margin-top: 10px;
    padding: 8px 10px 10px;
    border-top: 2px dashed #EBB3A9;
  }
  .driver-frost-ingredients-names {
    margin: 4px 0 0;
    font-size: 13px;
    font-weight: 700;
    line-height: 1.4;
    color: ${PINK};
  }
  .driver-frost-basic-bar {
    margin-top: 16px;
    margin-bottom: 12px;
    padding-top: 14px;
    padding-bottom: 8px;
    border-top: 2px dashed #EBB3A9;
  }
  .driver-frost-single-panel { margin-top: 12px; }
  .driver-calc-select-wrap {
    position: relative;
    margin-top: 6px;
  }
  .driver-calc-select {
    width: 100%;
    appearance: none;
    -webkit-appearance: none;
    border: 2px solid #EBB3A9;
    border-radius: 14px;
    background: linear-gradient(180deg, #FFFBFC 0%, #FFF7FA 100%);
    padding: 14px 48px 14px 16px;
    font-size: 16px;
    font-weight: 800;
    color: #2D2D2D;
    line-height: 1.25;
    min-height: 54px;
    box-shadow: inset 0 1px 2px rgba(0,0,0,0.04);
  }
  .driver-calc-select:focus {
    outline: none;
    border-color: ${PINK};
    box-shadow: 0 0 0 3px rgba(238, 38, 119, 0.14);
  }
  .driver-calc-select:disabled {
    opacity: 0.55;
  }
  .driver-calc-select-chevron {
    position: absolute;
    right: 16px;
    top: 50%;
    transform: translateY(-50%);
    pointer-events: none;
    color: ${PINK};
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .driver-calc-select-empty {
    margin-top: 6px;
    border-radius: 14px;
    border: 2px dashed #EBB3A9;
    background: #FFF7FA;
    padding: 14px 16px;
    font-size: 14px;
    font-weight: 600;
    color: rgba(45,45,45,0.55);
    min-height: 54px;
    display: flex;
    align-items: center;
  }
`;
